export default __webpack_public_path__ + "static/Lato-Thin-01923cbbba31d9cb7f29626b20775cdd.ttf";